import React, {useEffect} from 'react' 
import Aos from 'aos';
import "aos/dist/aos.css";
import { Component } from 'react';
import axios from "../../../axios-order";

class ContactForm extends Component {
     state = {
        contatcus: {
          fullname: "",
          email: "",
          message: "",
        }
      };
      componentDidMount(){
        Aos.init({duration: 2000})
      }
      handleUserInput = (e) => {
          console.log(e.target.value);
        const value = e.target.value;
        this.setState({
          ...this.state,
          contatcus: {
            ...this.state.contatcus,
            [e.target.name]: value,
          },
        });
      };
    
     submitForm = (e) => {
        e.preventDefault();
        console.log(this.state.contatcus);
        this.props.onSetLoader();
        axios
            .post("contact-us", this.state.contatcus)
            .then((response) => {
              console.log(response);
              if (response.status === 200) {
                this.props.onSetLoader();
                this.props.history.replace("/");
              }
            })
            .catch((error) => {
              console.log(error);
              this.props.onSetLoader();
            });     
    };
     render(){
        return(
            <div className="col-md-7" data-aos="fade-right">
                <form method="get" action="">
                    <div className="form-group">                                
                        <input id="fullname" className="form-control form-input2" type="text" name="fullname" placeholder="Full Name" onChange={this.handleUserInput} />
                    </div>
                    <div className="form-group">                                
                        <input id="email" className="form-control form-input2" type="text" name="email" placeholder="Email" onChange={this.handleUserInput} />
                    </div>
                    <div className="form-group position-relative">                                
                        <textarea id="message" className="form-control form-input2" type="text" name="message" placeholder="Message" rows="5" onChange={this.handleUserInput}></textarea>
                         
                    </div>
                    <div className="mt-2 text-right">
                        <button type="button" className="btn btn-send text-uppercase py-2"  onClick={this.submitForm}>Send</button>
                    </div>
                </form>
            </div>
         )
     }
}
export default ContactForm;